export default {
    ordertracking: {
        shutDown: '关闭',
        cancel: '取消',
    }
}